import axios from 'axios';
export default (id) => {
  const promise = new Promise((resolve, reject) => {
    axios
      .get(`${process.env.VUE_APP_API_ADMIN_LOCATION}organizations/${id}/admins`, {})
      .then(({ data }) => {
        resolve(data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
